module.exports = __webpack_public_path__ + "d8095944bf74f100ef0f2724d352c06a.svg";